import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { AdmissionFormProps } from '../../../utils/interfaces';
import Loader from '../../general/Loader/Loader';
import InfoPopup from '../InfoPopup/InfoPopup';
import './AdmissionForm.css';

const AdmissionForm: React.FC<AdmissionFormProps> = ({
  apiService,
  scrollRef,
  cellData,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [titlePopup, setTitlePopup] = useState('Принято! 😊');
  const [textPopup, setTextPopup] = useState('Скоро мы с Вами свяжемся');
  const [showResult, setShowResult] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agreedPersonalData, setAgreedPersonalData] = useState(false);
  const [agreedPrivacyPolicy, setAgreedPrivacyPolicy] = useState(false);

  const handleAgreePersonalDataChange = () => {
    setAgreedPersonalData(!agreedPersonalData);
    if (errors.agreedPersonalData) {
      setErrors((prev) => ({ ...prev, agreedPersonalData: '' }));
    }
  };

  const handleAgreePrivacyPolicyChange = () => {
    setAgreedPrivacyPolicy(!agreedPrivacyPolicy);
    if (errors.agreedPrivacyPolicy) {
      setErrors((prev) => ({ ...prev, agreedPrivacyPolicy: '' }));
    }
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    childName: '',
    birthYear: '',
    level: 'Не умеет играть',
    phone: '',
    prefferableConnection: 'e-mail',
    additionalText: '',
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [resultMessage, setResultMessage] = useState('');

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });

    if (errors[event.target.name]) {
      setErrors((prev) => ({ ...prev, [event.target.name]: '' }));
    }
  };

  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    if (!formData.name.trim()) newErrors.name = 'Это поле обязательно';
    if (!formData.email.trim()) newErrors.email = 'Это поле обязательно';
    if (!formData.childName.trim())
      newErrors.childName = 'Это поле обязательно';
    if (!formData.birthYear.trim())
      newErrors.birthYear = 'Это поле обязательно';
    if (!formData.phone.trim()) newErrors.phone = 'Это поле обязательно';
    if (!agreedPersonalData)
      newErrors.agreedPersonalData =
        'Обязательно нужно дать согласие на обработку персональных данных и подтвердить ознакомление с политикой конфиденциальности';
    if (!agreedPrivacyPolicy)
      newErrors.agreedPrivacyPolicy =
        'Обязательно нужно дать согласие на обработку персональных данных и подтвердить ознакомление с политикой конфиденциальности';
    return newErrors;
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    const result = await apiService.newStudentReq(formData);
    setLoading(false);

    if (result) {
      setResultMessage('Заявка принята');
      setTitlePopup('Принято! 😊');
      setTextPopup('Скоро мы с Вами свяжемся');
      setShowPopup(true);
      setFormData({
        name: '',
        email: '',
        childName: '',
        birthYear: '',
        level: 'Не умеет играть',
        phone: '',
        prefferableConnection: 'e-mail',
        additionalText: '',
      });
      setAgreedPersonalData(false);
      setAgreedPrivacyPolicy(false);
    } else {
      setResultMessage('Что-то сломалось');
      setTitlePopup('Что-то пошло не так! 😭');
      setTextPopup('Попробуйте отправить заявку еще раз.. 🙏');
      setShowPopup(true);
    }

    setShowResult(true);
  };

  useEffect(() => {
    if (cellData) {
      setFormData((prev) => ({
        ...prev,
        additionalText: `${cellData.group} ${cellData.day} ${cellData.time}`,
      }));
    }
  }, [cellData]);

  useEffect(() => {
    if (resultMessage) {
      const timer = setTimeout(() => setResultMessage(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [resultMessage]);

  return (
    <section
      ref={scrollRef}
      className="admissionform__wrapper"
      id="admissionForm"
    >
      <form className="admissionform__general" onSubmit={handleSubmit}>
        <h2 className="admissionform__title">ПОСТУПИТЬ</h2>

        <div className="admissionform__info">
          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="name">
              Контактное имя:
            </label>
            <input
              className="admissionform__input"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Елена Владимировна"
            />
            {errors.name && (
              <span className="admissionform__error">{errors.name}</span>
            )}
          </div>

          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="email">
              Email:
            </label>
            <input
              className="admissionform__input"
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="example@mail.ru"
            />
            {errors.email && (
              <span className="admissionform__error">{errors.email}</span>
            )}
          </div>

          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="childName">
              Имя ребенка:
            </label>
            <input
              className="admissionform__input"
              type="text"
              id="childName"
              name="childName"
              value={formData.childName}
              onChange={handleChange}
              placeholder="Ваня"
            />
            {errors.childName && (
              <span className="admissionform__error">{errors.childName}</span>
            )}
          </div>

          <div className="admissionform__block">
            <label htmlFor="level" className="admissionform__label">
              Шахматный уровень:
            </label>
            <select
              className="admissionform__input"
              id="level"
              name="level"
              value={formData.level}
              onChange={handleChange}
            >
              <option value="Не умеет играть">Не умеет играть</option>
              <option value="Новичок">Новичок</option>
              <option value="Средний">Средний</option>
              <option value="Продвинутый">Продвинутый</option>
            </select>
          </div>

          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="birthYear">
              Год рождения:
            </label>
            <input
              className="admissionform__input"
              type="number"
              id="birthYear"
              name="birthYear"
              value={formData.birthYear}
              onChange={handleChange}
              placeholder="2015"
              min="1917"
              max="2024"
            />
            {errors.birthYear && (
              <span className="admissionform__error">{errors.birthYear}</span>
            )}
          </div>

          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="phone">
              Телефон:
            </label>
            <input
              className="admissionform__input"
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="8 999 999 99 99"
            />
            {errors.phone && (
              <span className="admissionform__error">{errors.phone}</span>
            )}
          </div>

          <div className="admissionform__block">
            <label
              htmlFor="prefferableConnection"
              className="admissionform__label"
            >
              Предпочтительный способ связи:
            </label>
            <select
              className="admissionform__input"
              id="prefferableConnection"
              name="prefferableConnection"
              value={formData.prefferableConnection}
              onChange={handleChange}
            >
              <option value="e-mail">e-mail</option>
              <option value="телефон">телефон</option>
            </select>
          </div>

          <div className="admissionform__block">
            <label className="admissionform__label" htmlFor="additional">
              Дополнительно:
            </label>
            <input
              className="admissionform__input admissionform__input_text"
              type="text"
              id="additional"
              name="additionalText"
              value={formData.additionalText}
              onChange={handleChange}
              placeholder="Доп. инфо"
            />
          </div>
        </div>
        <div className="admissionform__block admissionform__consent">
          <label className="admissionform__label admissionform__checkbox-label">
            <input
              type="checkbox"
              checked={agreedPersonalData}
              onChange={handleAgreePersonalDataChange}
            />
            <span>
              Я даю своё согласие на{' '}
              <Link
                to="/personal_data_consent"
                className="admission_form_cookieprivacypolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                обработку Персональных данных
              </Link>
            </span>
          </label>

          <label className="admissionform__label admissionform__checkbox-label">
            <input
              type="checkbox"
              checked={agreedPrivacyPolicy}
              onChange={handleAgreePrivacyPolicyChange}
            />
            <span>
              Я ознакомлен(а) с{' '}
              <Link
                to={'/privacy_policy'}
                className="admission_form_cookieprivacypolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Политикой конфиденциальности
              </Link>
              {} в отношении персональных данных и файлов cookie
            </span>
          </label>

          {(errors.agreedPersonalData || errors.agreedPrivacyPolicy) && (
            <span className="admissionform__error">
              {errors.agreedPersonalData || errors.agreedPrivacyPolicy}
            </span>
          )}
        </div>

        <button type="submit" className="admissionform__button">
          Оставить заявку
        </button>

        {loading && <Loader />}
        {showResult && (
          <div className="admissionform__result">
            <p className="admissionform__feedback">{resultMessage}</p>
          </div>
        )}
      </form>

      {showPopup && (
        <InfoPopup
          onClose={() => setShowPopup(false)}
          title={titlePopup}
          text={textPopup}
        />
      )}
    </section>
  );
};

export default AdmissionForm;
